/**
 * 预约看车处理
 */
import React, { Component } from 'react';
import { Modal, Form, Input, DatePicker, Switch, List, Comment } from 'antd';
import moment from 'moment';

import http from '../../../axios/http';
import messager from '../../ui/messager';

const fields = [{
    "text": "车商",
    "field": "memberName",
    "disabled": true
}, {
    "text": "车辆",
    "field": "vehicleName",
    "disabled": true
}, {
    "text": "用户昵称",
    "field": "name",
    "disabled": true
}, {
    "text": "用户电话",
    "field": "tel",
    "disabled": true,
}, {
    "text": "预约时间确定",
    "field": "appointExact",
    "radio": true
}, {
    "text": "最早到店时间",
    "field": "appointmentStartTime",
    "date": true,
    rules: [
        { required: true, message: '最早到店时间不能为空!' },
    ]
}, {
    "text": "最晚到店时间",
    "field": "appointmentEndTime",
    "date": true,
    rules: [
        { required: true, message: '最晚到店时间不能为空!' },
    ]
}, {
    "text": "处理意见",
    "field": "content",
    "textarea": true,
    rules: [
        { required: true, message: '处理意见不能为空!' },
    ]
}];


class VehicleAppointmentEditForm extends Component {

    save = () => {
        const form = this.props.form;
        form.validateFields((err, values) => {
            if (err) {
                return;
            }
            values["id"] = this.props.editData.id;
            if (values["appointmentStartTime"] != null) {
                values["appointmentStartTime"] = values["appointmentStartTime"].format("YYYY-MM-DD HH:mm:ss");
            }
            if (values["appointmentEndTime"] != null) {
                values["appointmentEndTime"] = values["appointmentEndTime"].format("YYYY-MM-DD HH:mm:ss");
            }
            values["appointExact"] = values["appointExact"] ? 1 : 0;
            http.post({
                url: '/vehicleAppointment/dealAppointment',
                data: values,
                success: (res) => {
                    this.props.successCallback(this.props.queryData);
                    this.props.onCancel();
                    messager.notify("保存成功！");
                }
            });
        });
    };

    radioChange = (value) => {
        const { editData } = this.props;
        if (value) {
            editData.appointExact = 1;
        } else {
            editData.appointExact = 0;
        }
    }


    createDom = (data) => {
        const { form, editData } = this.props;
        const { getFieldDecorator } = form;
        let dom = [];
        for (let i = 0; i < data.length; i++) {
            let item = data[i];
            if (item.date && editData["appointExact"] === 0) {
                continue;
            }
            let itemDom = (
                <Form.Item key={i} label={item.text + "："}>
                    {
                        getFieldDecorator(item.field, {
                            rules: item.rules,
                            initialValue: item.date ? (editData[item.field] == null || editData[item.field] === "" ? null : moment(editData[item.field]))
                                : item.radio ? editData[item.field] === 1
                                    : editData[item.field],
                            valuePropName: item.radio ? 'checked' : 'value'
                        })(
                            item.date ? <DatePicker showTime={true} style={{ width: '100%' }} />
                                : item.radio ? <Switch checkedChildren="是" unCheckedChildren="否" onChange={this.radioChange} />
                                    : item.textarea ? <Input.TextArea disabled={item.disabled} />
                                        : <Input disabled={item.disabled} />
                        )
                    }
                </Form.Item>
            );
            dom.push(itemDom);
        }
        return dom;
    };


    render() {
        const { visible, onCancel, editData } = this.props;
        return (
            <Modal
                visible={visible}
                title="预约看车处理"
                okText="保存"
                cancelText="取消"
                maskClosable={false}
                onCancel={onCancel}
                onOk={this.save}
                afterClose={() => { this.props.form.resetFields() }}
            >
                <Form layout="vertical" labelCol={{ span: 6 }} wrapperCol={{ span: 18 }}>
                    {this.createDom(fields)}
                    {
                        editData["contentArray"] != null ?
                            <List
                                itemLayout="horizontal"
                                dataSource={editData["contentArray"]}
                                renderItem={item => (
                                    <List.Item>
                                        <Comment
                                            author={item["name"]}
                                            datetime={item["insertTime"]}
                                            content={item["content"]}
                                        />
                                    </List.Item>
                                )}
                            /> : ""
                    }
                </Form>
            </Modal>
        );
    }
}

const VehicleAppointmentEdit = Form.create()(VehicleAppointmentEditForm);

export default VehicleAppointmentEdit;